import { useState, useEffect } from 'react'

import Select from '@components/Select'
import Textfield from '@components/Textfield'

import { concatString } from 'content/components/helpers'
// atm react-select lib doesn't support `required` prop
// https://github.com/JedWatson/react-select/issues/3140

const RequiredSelect = ({ required, value, ...props }) => {
    const [subSelectValue, setSubSelectValue] = useState([])
    const allConditionalFields = props.options.find(field => field.conditionalFields)
    let selectedConditionalFields

    if (allConditionalFields && value?.value === allConditionalFields.label) {
        selectedConditionalFields = allConditionalFields.conditionalFields
    }

    const showConditionalField = selectedConditionalFields && value?.value !== ''
    const requiredSelectValue = label => subSelectValue?.find(item => item.label === label)
    const clearSubFields =
        (value?.value === '' || allConditionalFields?.label !== value?.value) && subSelectValue.length > 0
    const textSubSelectValue = subSelectValue.filter(value => value.type === 'text')
    const selectSubSelectValue = subSelectValue.filter(value => value.type === 'select')

    useEffect(() => {
        if (clearSubFields) {
            selectSubSelectValue.forEach(item =>
                props.onChange({
                    subSelectLabel: item.label,
                    value: '',
                })
            )

            setSubSelectValue([...subSelectValue.filter(item => item.type !== 'select')])
        }
    }, [value])

    useEffect(() => {
        if (clearSubFields && selectSubSelectValue.length === 0) {
            textSubSelectValue.forEach(item => props.onChangeTextfield(item.label, '', item.label))
            setSubSelectValue([])
        }
    }, [value, selectSubSelectValue])

    return (
        <>
            <Select {...props} />
            {required && (
                <input autoComplete="off" className="hidden-input" value={value ? value?.value : ''} required={true} />
            )}
            {showConditionalField &&
                selectedConditionalFields.map((field, index) => {
                    if (field.type === 'textarea')
                        return (
                            <div className="mt-4">
                                <Textfield
                                    onChange={e => {
                                        setSubSelectValue([
                                            ...subSelectValue,
                                            {
                                                label: field.label,
                                                value: e.target.value,
                                                type: 'text',
                                            },
                                        ])
                                        props.onChangeTextfield(field.label, e.target.value, field.label)
                                    }}
                                    label={field.label}
                                    name={field.label}
                                    type="text"
                                    required={field.isRequired}
                                />
                            </div>
                        )
                    if (field.type === 'select') {
                        const conditionalSelectProps = {
                            onChange: e => {
                                e !== null
                                    ? setSubSelectValue([
                                          ...subSelectValue,
                                          {
                                              label: field.label,
                                              value: e.label,
                                              type: 'select',
                                          },
                                      ])
                                    : setSubSelectValue([...subSelectValue.filter(item => item.label !== field.label)])
                                return props.onChange({
                                    subSelectLabel: field.label,
                                    value: e?.label || '',
                                })
                            },
                            onChangeTextfield: e =>
                                props.onChangeTextfield(concatString(field.label), field.label, e.label),
                            options: field.selectOptions,
                            placeholder: field.label,
                            isClearable: true,
                            required: field.isRequired,
                        }
                        return (
                            <div className="mt-4">
                                <Select {...conditionalSelectProps} key={index} />
                                {field.isRequired && (
                                    <input
                                        autoComplete="off"
                                        className="hidden-input"
                                        value={requiredSelectValue(field.label)?.value || ''}
                                        required={true}
                                        name={concatString(field.label)}
                                    />
                                )}
                            </div>
                        )
                    }
                })}
        </>
    )
}
export default RequiredSelect
